import React, { useState, useRef, useEffect } from "react";
import "../css/FloatingButtons.css";

import soundFile from "../assets/sound.mp3";


const Float = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState({ top: 400, right: 25 });
  const [openDirection, setOpenDirection] = useState("right"); // Initialize with default direction
  const containerRef = useRef(null);
  const [muted, setMuted] = useState(false); // Change from true to false
  const audioRef = useRef(null);

  const toggleMute = () => {
    setMuted(!muted);
  };

  const toggleButtons = () => {
    setIsOpen(!isOpen);
  };

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handleMouseDown = (e) => {
    e.preventDefault();
    const element = containerRef.current;
    const startX = e.clientX;
    const startY = e.clientY;
    const initialRight = parseFloat(window.getComputedStyle(element).right);
    const initialTop = parseFloat(window.getComputedStyle(element).top);

    const handleMouseMove = (e) => {
      const newRight = initialRight - (e.clientX - startX);
      const newTop = initialTop + (e.clientY - startY);
      
      setPosition({
        top: newTop,
        right: newRight,
      });


      const screenWidth = window.innerWidth;
      const containerWidth = element.offsetWidth;
      setOpenDirection(newRight + containerWidth / 2 < screenWidth / 2 ? "right" : "left");
    };

    const handleMouseUp = () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleTouchStart = (e) => {
    const touch = e.touches[0];
    const element = containerRef.current;
    const startX = touch.clientX;
    const startY = touch.clientY;
    const initialRight = parseFloat(window.getComputedStyle(element).right);
    const initialTop = parseFloat(window.getComputedStyle(element).top);

    const handleTouchMove = (e) => {
      const touch = e.touches[0];
      const newRight = initialRight - (touch.clientX - startX);
      const newTop = initialTop + (touch.clientY - startY);
      
      setPosition({
        top: newTop,
        right: newRight,
      });

      // Determine if the floating container is on the left or right side of the screen
      const screenWidth = window.innerWidth;
      const containerWidth = element.offsetWidth;
      setOpenDirection(newRight + containerWidth / 2 < screenWidth / 2 ? "right" : "left");
    };

    const handleTouchEnd = () => {
      document.removeEventListener("touchmove", handleTouchMove);
      document.removeEventListener("touchend", handleTouchEnd);
    };

    document.addEventListener("touchmove", handleTouchMove);
    document.addEventListener("touchend", handleTouchEnd);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Clean up function to remove the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.muted = muted;
    }
  }, [muted]);

  useEffect(() => {
    // Simpler audio handling
    const handleUserInteraction = () => {
      if (audioRef.current) {
        audioRef.current.play()
          .then(() => {
            setMuted(false);
          })
          .catch(err => {
            console.log("Could not play audio:", err);
          });
        
        // Remove listeners after first attempt
        document.removeEventListener('click', handleUserInteraction);
        document.removeEventListener('touchstart', handleUserInteraction);
      }
    };
    
    // Try to play immediately (will likely fail due to browser policies)
    if (audioRef.current) {
      audioRef.current.play()
        .then(() => {
          setMuted(false);
          console.log("Autoplay successful");
        })
        .catch(() => {
          console.log("Autoplay blocked - waiting for user interaction");
        });
    }
    
    // Add listeners for user interaction
    document.addEventListener('click', handleUserInteraction);
    document.addEventListener('touchstart', handleUserInteraction);
    
    return () => {
      document.removeEventListener('click', handleUserInteraction);
      document.removeEventListener('touchstart', handleUserInteraction);
    };
  }, []);

  return (
    <div
      className="floating-container"
      ref={containerRef}
      onMouseDown={handleMouseDown}
      onTouchStart={handleTouchStart}
      style={{ top: `${position.top}px`, right: `${position.right}px`, position: "fixed" }}
    >
    
      {/*  <img
                src={hat}
                alt="Profile"
                style={{     width: "60px",
                  position: "absolute",
                  zIndex: "100",
                  top: "-41px",
                  left: "4px",
                  pointerEvents: "none",
                }}
                
              />  */}

      <div className={"arrow-button"}  >
          {/*  <img className="w-10" src={Tree} alt="closed" /> */} 
          <audio
        ref={audioRef}
        src={soundFile}
        autoPlay
        loop
        muted={muted}
      />
      <button
        className="mute-btn"
        onClick={toggleMute}
        style={{
          position: "absolute",
          zIndex: 200,
          background: "rgba(255,255,255,0.8)",
          border: "none",
          borderRadius: "50%",
          width: "32px",
          height: "32px",
          cursor: "pointer",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "16px"  // Set a consistent font size
        }}
        aria-label={muted ? "Unmute" : "Mute"}
      >
        <span style={{ width: "16px", height: "16px", display: "flex", justifyContent: "center", alignItems: "center" }}>
          {muted ? "🔇" : "🔊"}
        </span>
      </button>
      </div>
     {/*  <div className={`floating-buttons ${isOpen ? "open" : ""} ${openDirection}`}>
      <button className="floating-btn">
    <a
      href="https://loginskip.com/"
      target="_blank"
      rel="noopener noreferrer"
    >
      <i className="fa-solid fa-rocket" style={{ color: "#d8e2f3" }}></i>
    </a>
  </button>
        <button className="floating-btn">
          <Link
            to="/blog"
            onClick={(e) => {
              e.preventDefault();
              openInNewTab("/blog");
            }}
          >
            <i className="fa-solid fa-book-open-reader" style={{ color: "#d8e2f3" }}></i>
          </Link>
        </button>
        <button className="floating-btn">
          <Link
            to="/trending"
            onClick={(e) => {
              e.preventDefault();
              openInNewTab("/trending");
            }}
          >
            <i className="fa-solid fa-arrow-trend-up" style={{ color: "#d8e2f3" }}></i>
          </Link>
        </button>
      </div> */}
    </div>
  );
};

export default Float;
